module.exports = __webpack_public_path__ + "img/liqing.53f94935.png";